module.exports = __webpack_public_path__ + "static/media/Pic-0226.17989a3b.jpg";